import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";
import { useLocale } from "./i18n/LocaleContext";

const LINKS = [
  { icon: FaGithub,   href: "https://github.com/guidoenr",      label: "github.com/guidoenr" },
  { icon: FaLinkedin, href: "https://linkedin.com/in/guidoenr", label: "linkedin.com/in/guidoenr" },
  { icon: FaEnvelope, href: "mailto:guidoenr4@gmail.com",       label: "guidoenr4@gmail.com" },
];

export function Footer() {
  const { t } = useLocale();

  return (
    <footer className="relative w-full mt-auto border-t border-zinc-200/60 dark:border-zinc-800/60 py-8 bg-white/40 dark:bg-zinc-950/40 backdrop-blur-sm">
      <div className="max-w-6xl mx-auto px-6 md:px-16">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500 dark:text-zinc-400">
            © {new Date().getFullYear()} Guido Enrique — {t("footer.tagline")}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs">
            {LINKS.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith("mailto:") ? undefined : "_blank"}
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-zinc-600 dark:text-zinc-400 hover:text-zinc-800 dark:hover:text-zinc-100 transition-colors"
              >
                <Icon className="w-3.5 h-3.5" />
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
